import React, { useState, useEffect } from 'react';
import SingleBlog from '../../components/Blog/SingleBlog';

const Blog = () => {
    const [blogs, setBlogs] = useState([]);
    const blogUrlBase = '/blog-details';
    const buttonText = 'Read More';

    // Helper: Strip HTML and limit to 30 words
    const trimDescription = (htmlString) => {
        // Remove HTML tags
        const text = htmlString.replace(/<[^>]+>/g, '');
        // Limit to first 30 words
        return text.split(' ').slice(0, 30).join(' ') + (text.split(' ').length > 30 ? '...' : '');
    };

    useEffect(() => {
        // Replace with your API endpoint
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blogs`)
            .then(res => res.json())
            .then(data => {
                // Sort descending by created_at and get latest three
                const sorted = data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                setBlogs(sorted.slice(0, 3));
            })
            .catch(err => console.error(err));
    }, []);

    return (
        <>
        {/*Blog One Start*/}
        <section className="blog-one">
            <div className="container">
                <div className="text-center section-title">
                    <div className="section-title__tagline-box">
                        <span className="section-title__tagline">Latests Blog</span>
                    </div>
                    <h2 className="section-title__title ">
                    Latest Insights & Updates 
                        <br /> from Our Blog
                    </h2>
                </div>
                <div className="row">
                    {
                        blogs.map(post => {
                            // Format date as "24 March"
                            const blogDate = new Date(post.created_at).toLocaleDateString(undefined, { day: '2-digit', month: 'long' });
                            return (
                                <SingleBlog 
                                    key={post.id}
                                    blogImage={post.image}
                                    blogDate={blogDate}
                                    blogTitle={post.title}
                                    blogDesc={trimDescription(post.description)}
                                    linkUrl={`${blogUrlBase}/${post.slug}`}
                                    linkText={buttonText}
                                />
                            );
                        })
                    }
                </div>
            </div>
        </section>
        {/*Blog One End*/}
        </>
    );
}

export default Blog;